import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(
      window.localStorage.getItem('user') || 'null'
    ),
    settings: {
      theme: '#4a5ca8'
    }
  },
  getters: {
    getTheme(state) {
      return state.settings.theme
    }
  },
  mutations: {
    setTheme(state, payload) {
      state.settings.theme = payload
    }
  },
  actions: {},
  modules: {}
})
